module.exports = __webpack_public_path__ + "media/application/images/ask-bg-04de4e44e706bfb8caa5f8e69704589b9cfb027b7cad7306a3db4a6702e885a1.png";